<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" v-show="isEnabled" />
      <feather-icon icon="CopyIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="openDuplicateConfirm"  />
      <feather-icon icon="ClockIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="openVersionPopup" />
      <feather-icon icon="MessageSquareIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="openCommentsPopup"  />
      <feather-icon icon="XIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="openCancelImportation" v-show="!isEnabled"   />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openDeleteConfirm" v-show="isEnabled && !isDeleted"/>
      <feather-icon icon="RotateCcwIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="openRestoreConfirm" v-show="isEnabled && isDeleted"/>
    </div>
</template>

<script>
export default {
  name: 'TimesheetActionsCellRenderer',
  computed: {
    isEnabled() {
      return this.params.data.timesheetImportationId === null;
    },
    isDeleted() {
      return this.params.data.isDeleted;
    }
  },
  methods: {
    editRecord () {
      this.params.context.componentParent.editData(this.params.data);
      //this.$router.push(`/apps/user/user-edit/${  268}`).catch(() => {})
      //this.$emit("editTimesheet", this.params.data.id);
    },
    openDuplicateConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('GradeControl.Timesheet.ConfirmDuplicate'),
        accept: this.duplicateRecord
      });
    },
    duplicateRecord () {
      this.params.context.componentParent.duplicateData(this.params.data);
    },
    openVersionPopup () {
      this.params.context.componentParent.openVersionPopup(this.params.data);
    },
    openCommentsPopup () {
      this.params.context.componentParent.openCommentsPopup(this.params.data);
    },
    openDeleteConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name,
        text: this.$t('GradeControl.Timesheet.ConfirmDelete'),
        accept: this.deleteRecord
      });
    },
    deleteRecord () {
      this.params.context.componentParent.deleteData(this.params.data.timesheetStagingEntryId);
    },
    openRestoreConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('GradeControl.Timesheet.ConfirmRestore'),
        accept: this.restoreRecord
      });
    },
    restoreRecord () {
      this.params.context.componentParent.restoreData(this.params.data);
    },
    openCancelImportation() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: name,
        text: this.$t('GradeControl.Timesheet.ConfirmCancelImport'),
        accept: this.cancelImportation
      });
    },
    cancelImportation () {
      this.params.context.componentParent.cancelImportation(this.params.data);
    }
  }
}
</script>
